import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from '@i18n';
import {
  Table,
  withLayout,
  Section,
  useFirstRender,
  Select,
  ActionModal,
  Icons,
} from '@casanova/casanova-common';
import { CellText, CellStatus } from 'components/ColumnsCells';
import { validateElement } from '../../../../utils/roles';
import { EDIT_VEHICLE_GENERAL_INFORMATION } from '../../../../utils/roles/permissions';

function VehicleSubstatusDetails({
  match,
  vehicleSubstatusDetails = [],
  fetchVehicleSubstatusDetails,
  createVehicleSubstatusManual,
  onlyFetchParams = false,
}) {
  const [isShowActionModalOpen, setIsShowActionModalOpen] = React.useState(
    false
  );
  const [substatusToChange, setSubstatusToChange] = React.useState(null);
  const vehicleSubstatusDetailsFormatted = [
    vehicleSubstatusDetails.reduce((acc, item) => {
      const { uuid, active } = item;
      acc[uuid] = active;
      return acc;
    }, {}),
  ];
  const StatusSelect = (props) => {
    const { value, column } = props;

    const handleChangeSubstatusManual = (e) => {
      // const { value } = e.target;
      // createVehicleSubstatusManual({
      //   uuid: match.params.id,
      //   substatusUuid: column.field,
      //   active: value === 'true',
      // });
      setSubstatusToChange({
        uuid: match.params.id,
        substatusUuid: column.field,
        active: e.target.value === 'true',
      });
      setIsShowActionModalOpen(true);
    };

    if (
      ![
        'a280df6f-1075-4ddf-8d06-b01720edc5ab', // Siniestro en circulación
        'd669cd55-e9ac-4657-bd97-b46d43a44c3a', // Venta a tercero
        'cc91a714-f494-481f-812e-dbd8528b664f', // PT por indemnizar
        '353c8cf0-50f9-466f-9fcd-32f03c828258', // Abuso de confianza
        '5fbc10d3-f017-429a-831b-89ae4b274f54', // Casos especiales
        '54247f5e-0fd0-4e30-871d-6ca80ed62ff5', // Sin señal
      ].includes(column.field)
    ) {
      return <CellStatus {...props} />;
    }

    return (
      <td style={{ minWidth: '200px' }}>
        <Select
          value={value?.toString()}
          name="substatus"
          options={[
            { label: 'Activo', value: 'true' },
            { label: 'Inactivo', value: 'false' },
          ]}
          // disabled={!validateElement(EDIT_VEHICLE_GENERAL_INFORMATION)}
          onChange={handleChangeSubstatusManual}
        />
      </td>
    );
  };
  // TODO: Find a better way to do this
  const columns =
    // vehicleSubstatusDetails
    [
      { substatus: '1b91116f-8c5d-4fe9-b394-16b1c835c20c', separated: false },
      { substatus: '76f495aa-bc7c-410f-bb4b-4c078e9c0173', separated: false },
      { substatus: 'c44359af-b3c6-425b-84c5-cb70e1ca76ae', separated: false },
      { substatus: '90efe52b-7357-4377-ac97-78912e98c13d', separated: false },
      { substatus: 'd8d40cbb-62a7-4b6e-83fb-9ffceffed08e', separated: false },
      { substatus: 'eb4ee1d9-ab1e-43e4-ba12-46b01661675b', separated: true },
      { substatus: 'e76ea0c3-61ee-4bc5-99e1-c1d3ec2d3deb', separated: true },
      { substatus: 'f979adef-752e-4708-9fc7-521bb48a1a31', separated: true },
      { substatus: 'a280df6f-1075-4ddf-8d06-b01720edc5ab', separated: false },
      { substatus: 'd669cd55-e9ac-4657-bd97-b46d43a44c3a', separated: false },
      { substatus: 'cc91a714-f494-481f-812e-dbd8528b664f', separated: false },
      { substatus: '353c8cf0-50f9-466f-9fcd-32f03c828258', separated: false },
      { substatus: '5fbc10d3-f017-429a-831b-89ae4b274f54', separated: false },
      { substatus: '54247f5e-0fd0-4e30-871d-6ca80ed62ff5', separated: false },
    ]
      .map((item) => ({
        ...vehicleSubstatusDetails.find((i) => i.uuid === item.substatus),
        separated: item.separated,
      }))
      .filter((item) => item)
      .map((item) => ({
        label: item.name,
        field: item.uuid,
        align: 'left',
        renderer: StatusSelect,
        columnHeaderStyle: item.separated
          ? {
              borderRight: '2px solid #FFF',
            }
          : {},
      }));

  const isFirstRender = useFirstRender();

  const vehicleUuid = useMemo(() => match.params.id, [match.params.id]);

  useEffect(() => {
    if (onlyFetchParams ? !isFirstRender : true) {
      fetchVehicleSubstatusDetails({ uuid: vehicleUuid });
    }
  }, [vehicleUuid, onlyFetchParams]);

  const handleAcceptChangeSubstatusManual = () => {
    if (!substatusToChange) {
      return;
    }
    const { uuid, substatusUuid, active } = substatusToChange;
    createVehicleSubstatusManual({
      uuid,
      substatusUuid,
      active,
    });
    setSubstatusToChange(null);
    setIsShowActionModalOpen(false);
  };

  if (!vehicleSubstatusDetails || vehicleSubstatusDetails.length === 0) {
    return null;
  }

  return (
    <Section
      title={i18n('VEHICLES__SECTIONS__VEHICLE_SUBSTATUS_DETAILS__TITLE')}
    >
      <ActionModal
        open={isShowActionModalOpen}
        icon={<Icons.StatusWarning />}
        onClose={() => setIsShowActionModalOpen(false)}
        onAction={handleAcceptChangeSubstatusManual}
        title="Modificar substatus"
        message="¿Está seguro de ejecutar los cambios?"
        actionLabel="Aceptar"
        closeLabel="Cancelar"
      />
      <Table
        preHeader={
          <tr style={{ textAlign: 'center' }}>
            <th colSpan={6} style={{ borderRight: '2px solid #FFF' }}>
              Z-FLEET
            </th>
            <th style={{ borderRight: '2px solid #FFF' }}>Z-TALLERES</th>
            <th style={{ borderRight: '2px solid #FFF' }}>Z-TRASLADOS</th>
            <th colSpan={6}>ZIGA</th>
          </tr>
        }
        primary
        emptyMessage={i18n('ERROR__COMMONS__NOT_FOUND')}
        dataList={vehicleSubstatusDetailsFormatted}
        columns={columns}
        style={{ borderCollapse: 'collapse' }}
      />
    </Section>
  );
}

VehicleSubstatusDetails.propTypes = {
  onlyFetchParams: PropTypes.bool,
};

export default withLayout(VehicleSubstatusDetails, { withLoader: false });
